import { useSimpleChoicesStore } from '@/features/ChoicesLists/Simple/store';
import type { SimpleChoiceType } from '@/features/ChoicesLists/Simple/types';
import type { ChoiceValueValidation } from '@/features/ChoicesLists/types';
import { getEntries } from '@/utils/objects/objects';

export const validateChoiceValues = async (
  validation: ChoiceValueValidation,
): Promise<ChoiceValueValidation> => {
  const invalidChoices: ChoiceValueValidation = {};

  const choicesToLoad = Object.keys(validation) as SimpleChoiceType[];

  if (choicesToLoad.length > 0) {
    await useSimpleChoicesStore().loadChoicesAsynchronously(choicesToLoad);

    getEntries(validation).forEach(([choice, fieldInfo]) => {
      if (
        fieldInfo !== undefined &&
        !useSimpleChoicesStore().data[choice].values.some(
          (v) => v.value === fieldInfo.value,
        )
      ) {
        invalidChoices[choice] = fieldInfo;
      }
    });
  }

  return invalidChoices;
};
